import type { Headline } from '@/content/site'

/** Props for {@link Segments}. */
export interface SegmentsProps {
  /** A headline from `src/content/site.ts`. */
  segments: Headline
  /** Extra class for the `<em>` accent words (global CSS already makes them serif italic). */
  emClassName?: string
}

/**
 * Renders a content headline. Segments with `em: true` become `<em>`, which global CSS
 * sets in Instrument Serif italic inside headings. It renders inline, with no wrapper.
 *
 * @example <h2 id="pipeline-title"><Segments segments={pipeline.title} /></h2>
 */
export function Segments({ segments, emClassName }: SegmentsProps) {
  return (
    <>
      {segments.map((segment, index) =>
        segment.em ? (
          <em key={index} className={emClassName}>
            {segment.text}
          </em>
        ) : (
          <span key={index}>{segment.text}</span>
        ),
      )}
    </>
  )
}
